// imports section Start
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
import {
  Box,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import CashReceiptHeaderA4 from "../../components/bill/a4/CashReceiptHeaderA4";
import CashReceiptBodyA4 from "../../components/bill/a4/CashReceiptBodyA4";
import CashReceiptFooterA4 from "../../components/bill/a4/CashReceiptFooterA4";
import {
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import {
  SETTINGS_API_01,
  SETTINGS_API_09,
  SETTINGS_API_20,
  ORDER_API_06,
} from "../../api/ApiModel";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { decodeUrl } from "../../utils/common/UrlUtils";
import { QRCodeCanvas } from "qrcode.react";
import { WEB_URL } from "../../api/EndPoints";
// imports section End

function CashReceiptA4() {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const location = useLocation();
  const [billOptions, setBillOptions] = useState([]);
  const [mappedOptions, setMappedOptions] = useState(new Set());
  const [dataLoaded, setDataLoaded] = useState(true);
  const [error, setError] = useState(null);
  const [billDetails, setBillDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  const queryParams = new URLSearchParams(window.location.search);
  const encodedOrderCode = queryParams.get("orderCode");
  const orderCode = decodeUrl(encodedOrderCode);

  const source = queryParams.get("source");

  const qpdata = decodeUrl(queryParams.get("data"));
  const COMPCODE = qpdata.split("|")[0];
  const LOCCODE = qpdata.split("|")[1];
  const RESTCODE = qpdata.split("|")[2];

  console.log("qpdata", qpdata);

  useEffect(() => {
    if (orderCode) {
      fetchBillDetails();
    }
  }, [orderCode]);

  useEffect(() => {
    fetchBillOptions();
    fetchMappedOptions();
  }, []);

  // Hooks end

  // API calls start
  const fetchBillDetails = async () => {
    try {
      const params = {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        ORDERCODE: orderCode,
      };
      const response = await externalgetApi(ORDER_API_06, "GET", params);

      console.log("fetchBillDetails fetchBillDetails", response);
      setBillDetails(response);
    } catch (error) {
      console.error("Error fetching bill details:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchBillOptions = async () => {
    try {
      const params = {
        STS: CON_STATUS_ACTIVE,
      };

      const response = await externalgetApi(SETTINGS_API_20, "GET", params);

      console.log("response mapped", response);
      setBillOptions(response);
    } catch (error) {
      console.error("Error fetching Bill Options:", error);
      setError(error);
    } finally {
      setDataLoaded(true);
    }
  };

  const fetchMappedOptions = async () => {
    try {
      const params = {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        STS: CON_STATUS_ACTIVE,
      };

      const response = await externalgetApi(SETTINGS_API_01, "GET", params);
      // Parse mapped options JSON (e.g., JTEXT field)

      console.log("bill mapped", response);
      const mappedOptionsArray = JSON.parse(response[0]?.JTEXT || "[]");
      const mappedIds = new Set(
        mappedOptionsArray.map((opt) => opt.BILLOPTCODE)
      ); // Using a Set for quick lookup
      setMappedOptions(mappedIds);
    } catch (error) {
      console.error("Error fetching Mapped Options:", error);
    }
  };
  // API calls end

  const generateQRCode = () => {
    const baseUrl = `${WEB_URL}CashReceipt?orderCode=${encodedOrderCode}&source=CashierSummery&data=${btoa(
      qpdata
    )}`;
    return baseUrl;
  };

  useEffect(() => {
    if (!loading && dataLoaded && !error) {
      setTimeout(() => {
        window.print();
      }, 200); // Delay to ensure rendering
    }
  }, [loading, dataLoaded, error]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        my: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          flexDirection: "column",
          my: 2,
          width: "210mm",
          height: "297mm",
          padding: "20mm",
          fontFamily: "Arial, sans-serif",
          border: "1px solid #ccc",
        }}
      >
        <CashReceiptHeaderA4
          billOptions={billOptions}
          mappedOptions={mappedOptions}
          orderPayload={billDetails}
        />
        <CashReceiptBodyA4
          billOptions={billOptions}
          mappedOptions={mappedOptions}
          orderPayload={billDetails}
          source={source}
        />

        <CashReceiptFooterA4
          billOptions={billOptions}
          mappedOptions={mappedOptions}
          orderPayload={billDetails}
          qrcode={<QRCodeCanvas value={generateQRCode()} size={100} />}
        />
      </Box>
    </Box>
  );
}

export default CashReceiptA4;
